import React from 'react';
import experienciaData from '../../Configuracion/experiencia_del_mes.json';

export function Experience() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">EXPERIENCIA DEL MES</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl text-primary mb-4">{experienciaData.titulo}</h2>
        
        <p className="text-gray-600 mb-6 whitespace-pre-wrap">
          {experienciaData.oferta}
        </p>
        
        <div className="flex flex-col items-center mb-6">
          <div className="flex items-center gap-2">
            {experienciaData.precioTachado && (
              <span className="text-gray-400 line-through">{experienciaData.precioTachado}€</span>
            )}
            <span className="text-3xl text-primary font-semibold">{experienciaData.precioOferta}</span>
          </div>
          {experienciaData.etiquetaDescuento && (
            <span className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm mt-2">
              {experienciaData.etiquetaDescuento}
            </span>
          )}
        </div>
        
        <div className="space-y-3">
          <a 
            href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
            className="block w-full bg-primary text-white text-center px-4 py-1.5 rounded-full hover:bg-primary/90 transition-colors"
          >
            Disfrutar experiencia
          </a>
          <a 
            href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
            className="block w-full border-2 border-primary text-primary text-center px-4 py-1.5 rounded-full hover:bg-primary/5 transition-colors"
          >
            Regalar experiencia
          </a>
        </div>
        
        <div className="mt-8 text-center space-y-2">
          <p className="text-sm text-gray-600">Válida hasta el {experienciaData.fechaValidez}</p>
          <p className="text-primary italic">"El mejor regalo que puedes darte a ti misma"</p>
        </div>
      </div>
    </div>
  );
}